<template>
  <div>
    <el-group-title title="合同附件表">
      <template slot="groupTitle">
        <el-form
          :model="form"
          :rules="rules"
          ref="form2"
          label-width="160px"
          class="ccui-form ccui-form-detail"
          style="overflow: visible"
        >
          <el-table
            :data="tableData"
            class="ccui-form-child-table"
            border
            max-height="99999"
          >
            <el-table-column
              :show-overflow-tooltip="true"
              label="序号"
              type="index"
              min-width="20%"
              height="36px"
            />
            <el-table-column
              :show-overflow-tooltip="true"
              prop="fileName"
              label="文件名称"
              min-width="140%"
            >
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              prop="fileSize"
              label="文件大小"
              min-width="70%"
            >
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              prop="scaleNum"
              label="操作"
              min-width="70%"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                <span
                  style="color: #0089ef; cursor: pointer"
                  @click="downloadFile(scope.row.fileInfoId)"
                  >下载</span
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </template>
    </el-group-title>
  </div>
</template>

<script>
import { getArgs } from "@/basa/utils";
export default {
  name: "contractFiles",
  props: {
    dataInfo: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      form: {},
      rules: {},
      downloadUrl: this.$addUrlPerFix(process.env.VUE_APP_DOWNLOAD_URL), //下载文件
      tableData: []
    };
  },
  methods: {
    downloadFile(uploadId) {
      window.open(
        `${this.downloadUrl}?uploadId=${uploadId}&agentId=${getArgs("a")}`
      );
    }
  },
  watch: {
    dataInfo() {
      this.tableData = this.dataInfo;
    }
  }
};
</script>
